import { Checkbox, PrimaryButton, Text, TextField, useTheme } from '@fluentui/react';
import React, { useContext } from 'react';
import PageBase from '../../components/PageBase/PageBase';
import Strings from '../../localization/strings';
import SignInWithMicrosoftButton from './components/SignInWithMicrosoftButton/SignInWithMicrosoftButton';
import { FormContext } from '../../providers/FormProvider';
import PageTitle from '../../components/PageTitle/PageTitle';
import pageImg from '../../img/graphic-design/1-03-leftSide.svg';
import './IntroPage.scss';
import TextDivider from '../../components/TextDivider/TextDivider';

export const IntroPageNameInputs: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
    const myStrings = Strings.introPage;
    const { introFormik } = useContext(FormContext);

    const firstNameError = introFormik.touched.firstName ? introFormik.errors.firstName : undefined;
    const lastNameError = introFormik.touched.lastName ? introFormik.errors.lastName : undefined;
    return (
        <div className="intro-page__name-inputs">
            <TextField className="intro-page__firstname rounded" type="text" autoComplete='given-name' placeholder={myStrings.firstName} errorMessage={firstNameError} {...introFormik.getFieldProps('firstName')} maxLength={128} disabled={disabled} />
            <TextField className="intro-page__lastname rounded" type="text" autoComplete='family-name' placeholder={myStrings.lastName} errorMessage={lastNameError} {...introFormik.getFieldProps('lastName')} maxLength={128} disabled={disabled} />
        </div>
    );
};

const IntroPage: React.FC = () => {
    const myStrings = Strings.introPage;
    const { introFormik, formFinalizationAction } = useContext(FormContext);
    const theme = useTheme();

    const emailError = introFormik.touched.email ? introFormik.errors.email : undefined;
    // Once the trial creation (finalization) has been kicked off, these values are already
    // captured and can no longer affect the trial. Lock them so it's clear they are no longer
    // modifiable when the user navigates back here.
    const isLocked = formFinalizationAction !== null;

    return (
        <PageBase imgSrc={pageImg} imgClassName='intro-page__image' imgStyles={{ minWidth: "unset", maxWidth: "360px" }}>
            <form onSubmit={introFormik.handleSubmit}>
                <div className="intro-page__top-wrap">
                    <PageTitle title={myStrings.title} subtitle={myStrings.subtitle} />
                    <SignInWithMicrosoftButton className="intro-page__ms-signin" disabled={isLocked} />
                </div>
                <TextDivider>{myStrings.orDivider}</TextDivider>
                <div className="intro-page__bottom-wrap">
                    <IntroPageNameInputs disabled={isLocked} />
                    <TextField type="email" className="intro-page__email rounded" autoComplete='email' placeholder={myStrings.email} errorMessage={emailError} {...introFormik.getFieldProps('email')} maxLength={256} disabled={isLocked} />
                    <div>
                        <Checkbox
                            className="intro-page__terms-conditions"
                            required
                            disabled={isLocked}
                            onRenderLabel={() => myStrings.agreeToTermsAndConditions()}
                            checked={introFormik.values.agreeToTermsAndConditions}
                            {...introFormik.getFieldProps('agreeToTermsAndConditions')}
                        />
                        {introFormik.touched.agreeToTermsAndConditions && introFormik.errors.agreeToTermsAndConditions && (
                            <Text variant="small" style={{ color: theme.palette.redDark }}>
                                {introFormik.errors.agreeToTermsAndConditions}
                            </Text>
                        )}
                    </div>
                    <PrimaryButton className="page-base__next-btn rounded" type="submit" disabled={!introFormik.isValid}>
                        {myStrings.signUp}
                    </PrimaryButton>
                </div>
            </form>
        </PageBase>
    );
};

export default IntroPage;
